// utils/currentUserStore.ts

import {currentUserData} from "./user";

let currentUser: currentUserData | undefined = undefined;

export function SetCurrentUser(u: currentUserData | undefined) {
    currentUser = u;
}

export function GetCurrentUser(): currentUserData | undefined {
    return currentUser;
}